// extracted by mini-css-extract-plugin
export default {"summaryCard":"BullCardSummaries_summaryCard__0bdz9","container":"BullCardSummaries_container__jPLe9"};